import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { cancelCall } from "../../actions/sipActions";
import Standard from "../Standard";
import logo from "../../branding/current/logo.png";
import logoDark from "../../branding/current/logo_dark.png";
import RoundRejectButton from "../../components/buttons/RoundRejectButton";

export class Calling extends React.Component {
  outgoing = () => {
    return (
      <div className={"text-align-center margin-auto"}>
        <h1>
          {this.props.l10n("common.calling") + " " + this.props.callBName}
        </h1>
        <br />
        <RoundRejectButton
          text={this.props.l10n("common.cancel")}
          onClick={() => this.props.cancel()}
          kioskmode={false}
        />
      </div>
    );
  };

  render() {
    const { contrast, l10n } = this.props;
    return (
      <Standard
        logo={logo}
        logoDark={logoDark}
        contrast={contrast}
        l10n={l10n}
        include={this.outgoing()}
      />
    );
  }
}

Calling.propTypes = {
  l10n: PropTypes.func.isRequired,
  contrast: PropTypes.bool.isRequired,
  callBName: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  l10n: state.config.text,
  contrast: state.accessibility.isHighContrast,
  callBName: state.call.callBName,
});

const mapDispatchToProps = dispatch => ({
  cancel: () => {
    return dispatch(cancelCall());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Calling);






// WEBPACK FOOTER //
// ./src/kiosk/callStates/Call.jsx